import type { FormatRequest } from './types'

export const formatRequestKey = ({ expression }: FormatRequest) =>
  expression.replace(/[\r\n]/g, ' ')
